import { bindActiveAccountForTab, resolveBootstrapConfigForTab, } from '#pplx/frontend/apps/ask/spa-libs/resolveBootstrapConfigForTab.js';
// Bind account before any Search preload can issue an authenticated request.
export const bootstrapState = resolveBootstrapConfigForTab();
const { config, cachedSession, sessionFetchPromise } = bootstrapState;
// Prerender sessionStorage does not survive activation. Rebind inside the live tab.
if (document.prerendering) {
    document.addEventListener('prerenderingchange', () => {
        bindActiveAccountForTab(() => ({ cachedSession, sessionFetchPromise }));
    }, { once: true });
}
window.__PPL_CONFIG__ = config;
//# sourceMappingURL=resolveSpaBootstrapState.js.map